import React from 'react'
import { parentUrl } from '../../App/App.config'
import pushGTMEvent from '../../util/helper/pushGTMEvent'

const configContents = ({
  auth: { loginWithRedirect },
  state: { userSession, langStrings },
}) => {
  const handleSwitchUser = () => {
    loginWithRedirect({
      appState: {
        returnTo: parentUrl,
      },
      prompt: 'login',
      redirectMethod: 'replace', // needed to avoid window.parent.history write error
      redirectTarget: window.parent.location,
    })
  }
  return [
    {
      isTitle: true,
      hasLargeBottom: true,
      description: langStrings
        ? langStrings.reviewAccountInfo.pageTitle
        : '1. Review your account information',
      id: 'adsk-page-title',
    },
    {
      description: langStrings
        ? langStrings.reviewAccountInfo.signedInAs
        : 'You are signed in as:',
      style: { fontWeight: 'bold' },
    },
    {
      description: `${userSession.first} ${userSession.last}`,
      style: { fontWeight: 'bold' },
    },
    {
      description: userSession.email,
      style: { fontWeight: 'bold' },
      paragraphStyle: { marginBottom: '40px' },
    },
    {
      description: langStrings
        ? langStrings.reviewAccountInfo.emailConfirm
        : 'We will use this email to pull up your account and send you a confirmation.',
      paragraphStyle: { marginBottom: '30px' },
    },
    {
      isShown: true,
      isCustomComponent: true,
      customComponent: (
        <div style={{ marginBottom: '10px' }}>
          <a
            id="adsktm-cm-account-switch"
            style={{
              color: '#3c3c3c',
              fontSize: '14px',
              fontWeight: '400',
              fontFamily: 'ArtifaktElement,sans-serif',
              textDecoration: 'none',
              borderBottom: '1px dashed #999',
              cursor: 'pointer',
            }}
            onClick={handleSwitchUser}
          >
            {langStrings.reviewAccountInfo.differentAccount
              .replace(/<a>/g, '')
              .replace(/<\/a>/g, '')}
          </a>
        </div>
      ),
    },
    {
      description: langStrings
        ? langStrings.signIn.signInHelp
        : '<a target="_blank" href="https://knowledge.autodesk.com/contact-support/account-management/account-creation-sign-profile-management">Having trouble signing in?</a>',
    },
  ]
}

const configFooter = ({ auth: { isAuthenticated }, dispatch }) => ({
  handleBack: () => {
    if (isAuthenticated) pushGTMEvent('ContactInfo')
    else pushGTMEvent('Welcome')
    dispatch({ type: 'GO_TO_WELCOME_PAGE' })
  },
  hideNextButton: !isAuthenticated,
  handleNext: () => {
    pushGTMEvent('ProductInfo')
    dispatch({ type: 'GO_TO_CM_VALIDATION_PAGE' })
  },
  handleNextButtonId: 'adsktm-cm-next-button',
  handleBackButtonId: 'adsktm-cm-back-button',
})

export default {
  configContents,
  configFooter,
}
